const BACKEND_URL = (window as any)._env_?.REACT_APP_API_BASE_URL || "Value not set or Default Value";
const MOBILE_BREAKPOINT = (window as any)._env_?.REACT_APP_MOBILE_BREAK_POINT || 450;
const TABLET_BREAKPOINT = (window as any)._env_?.REACT_APP_TABLET_BREAK_POINT || 850;
const OPEN_WITH_DEVICE_BROWSER = (window as any)._env_?.REACT_APP_OPEN_WITH_DEVICE_BROWSER || false;
const DEPLOYMENT_RING = (window as any)._env_?.REACT_APP_DEPLOYMENT_RING || "DEV";

export { BACKEND_URL, MOBILE_BREAKPOINT, TABLET_BREAKPOINT, OPEN_WITH_DEVICE_BROWSER, DEPLOYMENT_RING };
